// src/components/LocationBreakdown.tsx
import { BankOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { Card, Statistic } from "antd";

interface LocationBreakdownProps {
  totalVolumeBK: string;
  totalVolumeLI: string;
}

export const LocationBreakdown: React.FC<LocationBreakdownProps> = ({
  totalVolumeBK,
  totalVolumeLI,
}) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 16,
        marginBottom: 16,
      }}
    >
      <Card>
        <Statistic
          title="Volume BK"
          value={totalVolumeBK}
          suffix="ft³"
          prefix={<BankOutlined />}
        />
      </Card>
      <Card>
        <Statistic
          title="Volume LI"
          value={totalVolumeLI}
          suffix="ft³"
          prefix={<EnvironmentOutlined />}
        />
      </Card>
    </div>
  );
};
